import React, { Component } from 'react';

import './styles.css';
import Icon from '../Icon';
import FilterWrapper from './FilterWrapper';

class Filter extends Component {
  _onHandlerClick = () => {
    const {
      toggleOverlay,
      identifier,
      requestFilterOptions,
      options,
      fixedOptions,
    } = this.props;

    toggleOverlay(identifier);
    if (requestFilterOptions && !fixedOptions) {
      if (!options || options.length === 0) {
        requestFilterOptions(identifier);
      }
    }
  };

  render() {
    const {
      bodyClass,
      label,
      alignDropdownRight,
      isOpen,
      isFetching,
      identifier,
      type,
      enumerator,
      options,
      placeholder,
      onFilter,
      currentValue,
      alwaysShowPlaceholder,
      hasNextPage,
      isNextPageLoading,
      loadNextPage,
      renderLeft,
      onSearchByTerm,
      searchTerm,
      noMinWidth,
      scrollAuto,
      itemSize,
      totalOptions,
      customComponent,
      customComponentProps,
      customStyles,
    } = this.props;

    let newLabel = label;

    if (
      type === 'select' &&
      currentValue &&
      typeof enumerator !== 'undefined'
    ) {
      newLabel = enumerator.filter(e => e.id === currentValue)[0].name;
    }
    return (
      <div
        className={`FilterComponent__root${` ${bodyClass}` || ''}${
          isOpen ? ' FilterComponent__root--open' : ''
        }`}
      >
        <div
          className="FilterComponent__handle"
          onClick={() => this._onHandlerClick(identifier)}
        >
          <span className="FilterComponent__handle-desc">
            {alwaysShowPlaceholder ? placeholder : newLabel}
          </span>
          <Icon
            className="FilterComponent__handle-icon"
            name="arrow_drop_down"
          />
        </div>
        <div
          className={`FilterComponent__dropdown${
            alignDropdownRight ? ' FilterComponent__dropdown--align-right' : ''
          }`}
        >
          {isOpen && (
            <FilterWrapper
              noMinWidth={noMinWidth}
              scrollAuto={scrollAuto}
              hasNextPage={hasNextPage}
              identifier={identifier}
              isNextPageLoading={isNextPageLoading}
              loadNextPage={loadNextPage}
              type={type}
              options={options}
              placeholder={placeholder}
              onFilter={onFilter}
              currentValue={currentValue}
              renderLeft={renderLeft}
              searchTerm={searchTerm}
              onSearchByTerm={onSearchByTerm}
              isFetching={isFetching}
              itemSize={itemSize}
              totalOptions={totalOptions}
              customComponent={customComponent}
              customComponentProps={customComponentProps}
              customStyles={customStyles}
            />
          )}
        </div>
      </div>
    );
  }
}

export default Filter;
